export function pickFromFileManager({ type = 'image' } = {}) {
    const uniq = `fm-${Math.random().toString(36).slice(2)}`;

    const lastSegment = window.location.pathname.split('/').filter(Boolean).pop();
    const encodeLastSegment = btoa(lastSegment || '');

    window.fmSetLink ??= (url, id) =>
        document.body.dispatchEvent(new CustomEvent(`fm_set_link_${id}`, { detail: url }));

    const pickerWindow = window.open(
        `/file-manager/fm-button?uniq=${encodeURIComponent(uniq)}&type=${type}&from=${encodeLastSegment}`,
        'fm'
    );

    return new Promise(resolve => {
        document.body.addEventListener(
            `fm_set_link_${uniq}`,
            e => {
                resolve(e.detail || null);
                if (pickerWindow && !pickerWindow.closed) pickerWindow.close();
            },
            { once: true }
        );
    });
}
